import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseComponent } from '../../../shared';


/**
 * Error page component for generic error.
 */
@Component({
	selector: 'app-error',
	templateUrl: './error.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class ErrorComponent extends BaseComponent { }
